module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_25-78ee3c2efec8f0aff23bc5c702ff6eb2.jpg";